<template>
  <div @dragover.prevent @drop="dropFile">
    <!-- <span v-if="isProgressBar" class="progressbar-wrapper mx-0 row">
      
      <w-image-progress-bar class="col-10 upload_progressbar"></w-image-progress-bar>
      <span calss="col-2" class="cancel-upload-button" @click="cancelUpload">&times;</span>
    </span>-->
    <span class="lato-regular field-headings">{{heading}}</span>
    <div class="row m-0 p-0">
      <!-- <div> -->
      <div class="col-auto m-0 p-0 borders-addFile p-1">
        <p class="m-auto alignment-padding">
          <img src="../assets/images/img_upload.svg" class="source-sans-pro mr-2" for="file" />Add File{{!isDeclaration?'s':''}}
          <input
            type="file"
            class="inputStyle cursor-pointer"
            :id="id"
            ref="file"
            accept=".csv, .png, .jpg, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, *.xlsx, application/pdf, application/msword"
            v-on:change="handleFileUpload()"
            multiple
          />
        </p>
      </div>
      <!-- </div> -->
      <div class="col-auto borders h-100" v-if="!isDeclaration">
        <label class="label-file cursor-pointer" for="file" v-if="this.addedFiles.length>0">
          <span>{{addedFiles.length}} files attached</span>
        </label>
        <label
          class="label-file cursor-pointer"
          for="file"
          v-if="this.addedFiles.length==0"
        >Or drag and drop here</label>
      </div>
      <div style="color: #00818d;font-size: 12px;padding: 0px !important;" class="col-12">
        Recommended: .pdf with size less than 200kb</div>
    </div>
    <widgetModal
      :trigger="triggerModal"
      :text="lastResponse"
      :title="modalTitle"
      :centered="true"
      :dontCloseWhenClickedOutside="true"
      :dontCloseWhenEscapePressed="true"
      :dontShowCloseIcon="true"
      :modalbuttonStyle="true"
      :showAlert="alertModal"
      :showSuccess="successModal"
      @eventClose="changeModalSuccess()"
    />
  </div>
</template>
<script>
// import ProgressBar from "./ProgressBar";
import widgetModal from "./newModalWidget";
export default {
  props: ["fileStatus", "heading", "nb", "module","isDeclaration"],
  components: {
    widgetModal
    // "w-image-progress-bar": ProgressBar
  },
  created() {
    // this.addedFiles = [];
    var self = this
    this.$root.$on('resetfile', function(){
      self.resetFile()
    })
  },
  data() {
    return {
      file: [],
      statusFileUpload: "files",
      // isProgressBar: false,
      fileName: [],
      fileNameLC: [],
      base64FileContents: [],
      addedFiles: [],
      triggerModal: false,
      lastResponse: false,
      alertModal: false,
      successModal: false
    };
  },
  computed: {
    last() {
      return Object.keys(this.fileName).length - 1;
    }
  },
  methods: {
    dropFile(event) {
      this.addedFiles = [];
      this.file = [];
      this.fileName = [];
      event.preventDefault();
      if (this.module && this.module == "Static") {
        if (event.dataTransfer.files.length > 1) {
          alert("Only one file can be upload");
          return;
        }
      }
      this.file = event.dataTransfer.files;
      for (let i = 0; i < this.file.length; i++) {
        this.fileName.push(this.file[i].name);
      }
      for (let i = 0; i < this.fileName.length; i++) {
        this.fileNameLC.push(this.fileName[i].split(".")[1].toLowerCase());
      }
      for (let i = 0; i < this.fileNameLC.length; i++) {
        if (
          this.fileNameLC[i] == "csv" ||
          this.fileNameLC[i] == "xls" ||
          this.fileNameLC[i] == "xlsx" ||
          this.fileNameLC[i] == "pdf" ||
          this.fileNameLC[i] == "doc" ||
          this.fileNameLC[i] == "docx" ||
          this.fileNameLC[i] == "png" ||
          this.fileNameLC[i] == "jpg"
        ) {
          this.addedFiles.push(this.file[i].name);
          if (this.addedFiles.length == this.file.length) {
            this.$emit("fileInputChange", this.file);
          }
        } else {
          this.fileName = [];
          this.fileNameLC = [];
          this.fileStatus = "false";
          this.file = [];
          this.triggerModal = true;
          this.lastResponse = "Please upload valid file";
          this.alertModal = true;
        }
      }
    },
    cancelUpload() {
      console.log("Upload Cancelled !");
      this.isProgressBar = false;
      this.file = "";
      this.statusFileUpload = "files";
      this.$emit("fileInputChange", "cancel");
    },
    handleFileUpload() {
      this.addedFiles = [];
      this.file = [];
      this.fileName = [];
      this.isProgressBar = true;
      this.file = this.$refs.file.files;
      if (this.module && this.module == "Static") {
        if (this.file.length > 1) {
          alert("Only one file can be upload");
          return;
        }
      }
      for (let i = 0; i < this.file.length; i++) {
        this.fileName.push(this.file[i].name);
      }
      for (let i = 0; i < this.fileName.length; i++) {
        this.fileNameLC.push(this.fileName[i].split(".")[1].toLowerCase());
      }
      for (let i = 0; i < this.fileNameLC.length; i++) {
        if (
          this.fileNameLC[i] == "csv" ||
          this.fileNameLC[i] == "xls" ||
          this.fileNameLC[i] == "xlsx" ||
          this.fileNameLC[i] == "pdf" ||
          this.fileNameLC[i] == "doc" ||
          this.fileNameLC[i] == "docx" ||
          this.fileNameLC[i] == "png" ||
          this.fileNameLC[i] == "jpg"
        ) {
          this.addedFiles.push(this.file[i].name);
          if (this.addedFiles.length == this.file.length) {
            this.$emit("fileInputChange", this.file);
          }
        } else {
          this.fileName = [];
          this.fileNameLC = [];
          this.fileStatus = "false";
          this.file = [];
          this.triggerModal = true;
          this.lastResponse = "Please upload valid file";
          this.alertModal = true;
        }
      }
      // this.$emit("fileInputChange", this.file);
    },
    changeModalSuccess() {
      this.triggerModal = false;
      this.alertModal = false;
    },
    resetFile(){      
      this.file=[]
      this.fileName=[]
      this.fileNameLC=[]
      this.addedFiles=[]
    }
  }
};
</script>

<style scoped>
.progressbar-wrapper {
  position: absolute;
  top: 130px;
  left: 19%;
  z-index: 10;
  width: 65%;
}
.upload_progressbar {
  margin-left: 0 !important;
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
.file-name {
  display: block;
  text-align: center;
  font-size: 14px !important;
}
.files input {
  outline: 2px dashed #92b0b3;
  outline-offset: -10px;
  -webkit-transition: outline-offset 0.15s ease-in-out,
    background-color 0.15s linear;
  transition: outline-offset 0.15s ease-in-out, background-color 0.15s linear;
  padding: 120px 0px 85px 35%;
  text-align: center !important;
  margin: 0;
  width: 100% !important;
}
.files input:focus {
  outline: 2px dashed #92b0b3;
  outline-offset: -10px;
  -webkit-transition: outline-offset 0.15s ease-in-out,
    background-color 0.15s linear;
  transition: outline-offset 0.15s ease-in-out, background-color 0.15s linear;
  border: 1px solid #92b0b3;
}
.files {
  position: relative;
}
.files:after {
  pointer-events: none;
  position: relative;
  top: 60px;
  left: 0;
  width: 50px;
  right: 0;
  height: 56px;
  content: "";
  background-image: url("../assets/images/img_upload.svg");
  display: block;
  margin: 0 auto;
  background-size: 100%;
  background-repeat: no-repeat;
}
.files:before {
  position: absolute;
  bottom: 10px;
  left: 0;
  pointer-events: none;
  width: 100%;
  right: 0;
  height: 57px;
  content: " or drop file to upload ";
  display: block;
  margin: 0 auto;
  color: #637381;
  font-weight: normal;
  font-size: 14px;
  text-align: center;
}
.color input {
  background-color: #f1f1f1;
}
.inputStyle {
  border: 2px dashed black;
  height: 100%;
  opacity: 0;
  width: auto;
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
}
.bordered {
  outline: 2px dashed #dfe3e8;
  height: 250px;
}
.form-group {
  margin-left: 1vw !important;
  margin-right: 1vw !important;
}
.labelStyle {
  width: 115px;
  min-height: 30px;
  text-align: center;
  background: #00000000;
  color: #212b36;
  font-size: 14px;
  border: solid 1px #dfe3e8;
  border-radius: 3px;
  margin: -130px auto 0;
  padding: 3px 10px;
  display: block;
}
.img_style {
  width: 64px;
  height: 57px;
  margin: auto;
  display: block;
}
.div_style {
  height: 250px;
  margin-top: 38px;
}
.button_styles {
  margin: 0 auto;
  display: block;
  margin-top: 23px !important;
  background: #00000000;
  color: #212b36;
  font-size: 14px;
  border: 1px solid #c4cdd5;
}
.file_status_message {
  margin-top: 20px !important;
  text-align: center;
  font-size: 14px;
  color: #473f52;
}
.text_below_button {
  text-align: center;
  margin-top: 13px !important;
  font-size: 14px;
  color: #637381;
  cursor: pointer;
}
</style>
<style>
.add-products-button.btn-primary.disabled,
.add-products-button.btn-primary:disabled {
  color: #fff !important;
}
.cancel-upload-button {
  font-size: xx-large;
  cursor: pointer;
  color: #637381;
}
.borders {
  border: 2px dotted #c4c4c4;
  border-radius: 3px;
  background-color: #f7f7f7;
}
.borders-addFile {
  border: solid 1px #c4c4c4;
  border-radius: 3px;
  border-top-right-radius: 0 !important;
  border-top-right-radius: 0 !important;
}
.alignment-padding {
  margin: auto !important;
  line-height: 1.5 !important;
  margin-top: 7% !important;
}
.label-file {
  height: 100% !important;
  line-height: 2.5;
  margin-bottom: 0 !important;
}
</style>  
